import { createFileRoute } from '@tanstack/react-router';
import { getInvoicesOptions } from '../../../../features/customer/invoices/queryOptions';
import { InvoicesTable } from '../../../../features/customer/invoices/table';
import { validateSearch } from '../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/invoices',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getInvoicesOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();
  return (
    <div className="col-span-full flex items-center justify-between">
      <InvoicesTable invoices={data} />
    </div>
  );
}
